// import 'iframe-resizer';
import Turbolinks from 'turbolinks';

// ブラウザのグローバルスコープに公開
window.Turbolinks = Turbolinks;

Turbolinks.start();
